import type { Program } from '@/types'

/** The Level and Degree filters' value for rows where nothing was extracted. */
export const NOT_STATED = '__not_stated__'

export type AttributeKey = 'level' | 'degree'

/** The values `rows` hold for `key`, sorted, then `NOT_STATED` when any row has none. */
export function filterOptions(rows: Program[], key: AttributeKey): string[] {
  const values = new Set<string>()
  let missing = false
  for (const row of rows) {
    const value = row[key]
    if (value) values.add(value)
    else missing = true
  }
  const sorted = [...values].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
  return missing ? [...sorted, NOT_STATED] : sorted
}

/** Whether `value` passes a filter: `all`, `NOT_STATED`, or one extracted value. */
export function matchesAttribute(value: string | null, filter: string): boolean {
  if (filter === 'all') return true
  if (filter === NOT_STATED) return !value
  return value === filter
}
